export class DummyData {
  static districts: any = {
    message: '',
    data: [
      {
        id: 1,
        district: 'الهنداوية',
        neighborhoods: '50',
        subneighborhoods: '30',
        unit: '5'
      },
      {
        id: 2,
        district: 'الهنداوية',
        neighborhoods: '50',
        subneighborhoods: '30',
        unit: '5'
      },
      {
        id: 3,
        district: 'الهنداوية',
        neighborhoods: '50',
        subneighborhoods: '30',
        unit: '5'
      },
      {
        id: 4,
        district: 'الهنداوية',
        neighborhoods: '50',
        subneighborhoods: '30',
        unit: '5'
      },
      {
        id: 5,
        district: 'الهنداوية',
        neighborhoods: '50',
        subneighborhoods: '30',
        unit: '5'
      },
      {
        id: 6,
        district: 'الهنداوية',
        neighborhoods: '50',
        subneighborhoods: '30',
        unit: '5'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static transitional_station: any = {
    message: '',
    data: [
      {
        id: 1,
        name: 'الهنداوية',
        districtsCount: '50'
      },
      {
        id: 2,
        name: 'الهنداوية',
        districtsCount: '5'
      },
      {
        id: 3,
        name: 'الهنداوية',
        districtsCount: '10'
      },
      {
        id: 4,
        name: 'الهنداوية',
        districtsCount: '4'
      },
      {
        id: 5,
        name: 'الهنداوية',
        districtsCount: '11'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static unit_type: any = {
    message: '',
    data: [
      {
        id: 1,
        name: 'الهنداوية',
        count: '5'
      },
      {
        id: 2,
        name: 'الهنداوية',
        count: '20'
      },
      {
        id: 3,
        name: 'الهنداوية',
        count: '50'
      },
      {
        id: 4,
        name: 'الهنداوية',
        count: '1'
      },
      {
        id: 5,
        name: 'الهنداوية',
        count: '50'
      },
      {
        id: 6,
        name: 'الهنداوية',
        count: '5'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static contracts: any = {
    message: '',
    data: [
      {
        id: 1,
        start_at: '1999-09-03',
        end_at: '1999-09-03',
        districts_count: 2,
        units_count: 10,
        contractor: {
          name_ar: 'احمد',
          name_en: 'Ahmed'
        },
        contact: {
          name: 'bla',
          email: 'bla@bla.com',
          phone: '+0512345678'
        }
      },
      {
        id: 2,
        start_at: '1999-09-03',
        end_at: '1999-09-03',
        districts_count: 2,
        units_count: 10,
        contractor: {
          name_ar: 'احمد',
          name_en: 'Ahmed'
        },
        contact: {
          name: 'bla',
          email: 'bla@bla.com',
          phone: '+0512345678'
        }
      },
      {
        id: 3,
        start_at: '1999-09-03',
        end_at: '1999-09-03',
        districts_count: 2,
        units_count: 10,
        contractor: {
          name_ar: 'احمد',
          name_en: 'Ahmed'
        },
        contact: {
          name: 'bla',
          email: 'bla@bla.com',
          phone: '+0512345678'
        }
      },
      {
        id: 4,
        start_at: '1999-09-03',
        end_at: '1999-09-03',
        districts_count: 2,
        units_count: 10,
        contractor: {
          name_ar: 'احمد',
          name_en: 'Ahmed'
        },
        contact: {
          name: 'bla',
          email: 'bla@bla.com',
          phone: '+0512345678'
        }
      },
      {
        id: 5,
        start_at: '1999-09-03',
        end_at: '1999-09-03',
        districts_count: 2,
        units_count: 10,
        contractor: {
          name_ar: 'احمد',
          name_en: 'Ahmed'
        },
        contact: {
          name: 'bla',
          email: 'bla@bla.com',
          phone: '+0512345678'
        }
      },
      {
        id: 6,
        start_at: '1999-09-03',
        end_at: '1999-09-03',
        districts_count: 2,
        units_count: 10,
        contractor: {
          name_ar: 'احمد',
          name_en: 'Ahmed'
        },
        contact: {
          name: 'bla',
          email: 'bla@bla.com',
          phone: '+0512345678'
        }
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static devices: any = {
    message: '',
    data: [
      {
        id: 1,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 2,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 3,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 4,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 5,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 6,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 7,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 8,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 9,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 10,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 11,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 12,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 13,
        name: 'جهاز 55',
        type: 'RFID'
      },
      {
        id: 14,
        name: 'جهاز 55',
        type: 'RFID'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static permissions: any = {
    message: '',
    data: [
      {
        id: 1,
        number: 465645,
        type: 'دمارات افراد',
        allowed_weight: 56465,
        net_weight: 1233
      },
      {
        id: 2,
        number: 465645,
        type: 'دمارات افراد',
        allowed_weight: 56465,
        net_weight: 1233
      },
      {
        id: 3,
        number: 465645,
        type: 'دمارات افراد',
        allowed_weight: 56465,
        net_weight: 1233
      },
      {
        id: 4,
        number: 465645,
        type: 'دمارات افراد',
        allowed_weight: 56465,
        net_weight: 1233
      }
    ],
    meta: {
      pagination: {
        currentPage: 1,
        firstPage: 1,
        lastPage: 1,
        perPage: 10,
        count: 3,
        totalRecords: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };
  static entrance_permission: any = {
    message: '',

    data: [
      {
        id: 1,
        entrance_id: 12123,
        type: 'employee',
        name: 'ddd',
        plate_number: 'Abs q234',
        start_date: '12-10-2012',
        end_date: '15-10-2012'
      },
      {
        id: 2,
        entrance_id: 12123,
        type: 'employee',
        name: 'ddd',
        plate_number: 'Abs q234',
        start_date: '12-10-2012',
        end_date: '15-10-2012'
      },
      {
        id: 3,
        entrance_id: 12123,
        type: 'visitor',
        name: 'ddd',
        plate_number: 'Abs q234',
        start_date: '12-10-2012',
        end_date: '15-10-2012'
      },
      {
        id: 4,
        entrance_id: 12123,
        type: 'employee',
        name: 'ddd',
        plate_number: 'Abs q234',
        start_date: '12-10-2012',
        end_date: '15-10-2012'
      },
      {
        id: 5,
        entrance_id: 12123,
        type: 'employee',
        name: 'ddd',
        plate_number: 'Abs q234',
        start_date: '12-10-2012',
        end_date: '15-10-2012'
      }
    ],
    meta: {
      pagination: {
        currentPage: 1,
        firstPage: 1,
        lastPage: 1,
        perPage: 10,
        count: 3,
        totalRecords: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static gates: any = {
    message: '',
    data: [
      {
        id: 1,
        name: 'بوابة 55',
        serial: '1312312',
        direction: 'دخول'
      },
      {
        id: 2,
        name: 'بوابة 55',
        serial: '5645646',
        direction: 'خروج'
      },
      {
        id: 3,
        name: 'بوابة 454',
        serial: '6435465',
        direction: 'دخول'
      },
      {
        id: 4,
        name: 'بوابة 45',
        serial: '4546',
        direction: 'دخول'
      },
      {
        id: 5,
        name: 'بوابة 51',
        serial: '46546',
        direction: 'خروج'
      },
      {
        id: 6,
        name: 'بوابة 412',
        serial: '645465',
        direction: 'دخول '
      },
      {
        id: 7,
        name: 'بوابة 445',
        serial: '6465',
        direction: 'خروج'
      },
      {
        id: 8,
        name: 'بوابة 211',
        serial: '65465',
        direction: 'دخول'
      },
      {
        id: 9,
        name: 'بوابة 4545',
        serial: '654654',
        direction: 'خروج'
      },
      {
        id: 10,
        name: 'بوابة 122',
        serial: '46546',
        direction: 'خروج'
      },
      {
        id: 11,
        name: 'بوابة 41100',
        serial: '5465',
        direction: 'خروج'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };
  static geofences: any = {
    message: '',
    data: [
      {
        id: 1,
        geofences_name: ' موقع ا',
        ID: '1312312',
        type: 'area'
      },
      {
        id: 2,
        geofences_name: ' موقع ب',
        ID: '1312312',
        type: 'pit'
      },
      {
        id: 3,
        geofences_name: ' موقع ج',
        ID: '1312312',
        type: 'pit'
      },
      {
        id: 4,
        geofences_name: ' موقع د',
        ID: '1312312',
        type: 'area'
      },
      {
        id: 5,
        geofences_name: ' موقع خ',
        ID: '1312312',
        type: 'area'
      },
      {
        id: 6,
        geofences_name: ' موقع م',
        ID: '1312312',
        type: 'pit'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static scales: any = {
    message: '',
    data: [
      {
        id: 1,
        name: 'asdfadas'
      },
      {
        id: 2,
        name: 'asdfadas'
      },
      {
        id: 3,
        name: 'asdfasdasd'
      },
      {
        id: 4,
        name: 'afdasdsad'
      },
      {
        id: 5,
        name: 'adsadasd'
      },
      {
        id: 6,
        name: 'Asdasdsad'
      },
      {
        id: 7,
        name: 'asfdsfds'
      },
      {
        id: 8,
        name: 'Asdasdasd'
      },
      {
        id: 9,
        name: 'dfsgfdg'
      },
      {
        id: 10,
        name: 'asdasdasd'
      },
      {
        id: 11,
        name: 'adasdasdas'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static vehicles_form: any = {
    id: 1,
    name: 'Vehicle Name',
    photo: 'https://dummyimage.com/300.png/09f/fff',
    plateNumber: '110 BAT',
    imei: 'this is missing on api',
    vin: 'this is missing on api',
    make: {
      id: 1,
      name: 'BMW'
    },
    model: {
      id: 1,
      name: 'X6'
    },
    year: '2020',
    type: {
      id: 10,
      name: 'Car'
    },
    color: '#1862db',
    license: '12345',
    expiry: '2020-09-19',
    status: {
      id: 2,
      name: 'Active',
      color: '#56d238'
    },
    odometer: {
      distance: 1000,
      createdAt: '2019-08-22T10:11:27+00:00'
    },
    groups: [
      {
        id: 4,
        name: 'KSA'
      },
      {
        id: 5,
        name: 'Technical'
      }
    ],
    specification: {
      width: 213,
      height: 123,
      length: 12312,
      curbWeight: 123,
      grossLength: 123
    },
    engine: {
      engineSummary: 'engine summary',
      engineBrand: 'engine brand',
      aspiration: 'turbocharger',
      camType: 'sohc',
      compressionRatio: 123,
      cylinders: 123,
      displacement: 123,
      fuelInduction: 'common-rail-direct-injection',
      engineFuelQuality: 'engine fuel quality',
      valves: 132,
      transmissionSummary: 'transmission summary',
      transmissionBrand: 'transmission brand',
      transmissionType: 'automatic',
      transmissionGear: 4
    },
    wheel: {
      driveType: '4x4',
      brakeSystem: 'air',
      frontTrackWidth: 213,
      rearTrackWidth: 123,
      wheelbase: 123,
      frontWheelDiameter: 213,
      rearWheelDiameter: 123,
      rearAxle: 123,
      frontTireType: 'front_tire_type',
      frontTirePsi: 'front_tire_psi',
      rearTireType: 'rear_tire_type',
      rearTirePsi: 'rear_tire_psi'
    },
    fuel: {
      fuelType: {
        id: 2,
        name: 'Gas'
      },
      fuelQuality: '95',
      fuelTank1Capacity: 50,
      fuelTank2Capacity: 30
    },
    purchase: {
      vendor: {
        id: 31,
        name: 'testtttt'
      },
      date: '2019-09-19',
      amount: 123,
      odometerOnPurchase: 123,
      comment: 'comment'
    },
    drivers: [
      {
        id: 1,
        name: 'Driver Name',
        photo: 'http://base_url/image/users/photo.png'
      },
      {
        id: 2,
        name: 'Driver Name',
        photo: 'http://base_url/image/users/photo.png'
      }
    ]
  };
  static zones: any = {
    message: '',
    data: [
      {
        id: 1,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.', 'asdfasd', 'sadasdsad', 'asdsa', 'asdsadsada'],
        gates_names: ['Et sed eum quisquam.', 'gate1', 'gate2', 'gate3', 'gate4', 'gate5'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 2,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 3,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 4,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 5,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 6,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 7,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 8,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 9,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      },
      {
        id: 10,
        name: 'Inventore incidunt laudantium.',
        devices_names: ['Accusantium laudantium numquam debitis.'],
        gates_names: ['Et sed eum quisquam.'],
        scales_name: 'Sint doloremque eaque ea.'
      }
    ],
    meta: {
      pagination: {
        current_page: 1,
        firstPage: 1,
        last_page: 1,
        perPage: 10,
        count: 3,
        total_records: 3,
        links: {
          first: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          last: 'http://dev.api.fleet.afaqy.co/api/v1/vehicles?page=1',
          previous: null,
          next: null
        }
      }
    }
  };

  static vehicleProfile: any = {
    id: 1,
    name: 'Ahmed Ezz',
    photo: 'http://dev.api.fleet.afaqy.co/image/vehicles/oEg4Y0Nua0k9sDFtAPUIC6tNyVXLMeET54NVkL6g.jpeg',
    plateNumber: '110 BAT',
    imei: 13579246810,
    vin: 2468,
    make: {
      id: 1,
      name: 'BMW'
    },
    model: {
      id: 1,
      name: 'X6'
    },
    year: 2020,
    type: {
      id: 1,
      name: 'car'
    },
    color: '#6bcaff',
    license: '12345',
    expiry: '2020-09-19',
    status: {
      id: 1,
      name: 'Active',
      color: '#56d238'
    },
    odometer: {
      distance: 1000,
      createdAt: '2019-08-22T10:11:27+00:00'
    },
    groups: [
      {
        id: 1,
        name: 'KSA'
      },
      {
        id: 2,
        name: 'Technical'
      }
    ],
    specification: {
      width: 20,
      height: 8,
      length: 40,
      curbWeight: 123,
      grossLength: 123
    },
    engine: {
      engineSummary: 'engine summary',
      engineBrand: 'BMW',
      aspiration: 'turbocharger',
      camType: 'sohc',
      compressionRatio: 4,
      cylinders: 1,
      displacement: 123,
      fuelInduction: 'common-rail-direct-injection',
      engineFuelQuality: 'engine fuel quality',
      valves: 132,
      transmissionSummary: 'transmission summary',
      transmissionBrand: 'transmission brand',
      transmissionType: 'automatic',
      transmissionGear: 4
    },
    wheel: {
      driveType: '4x4',
      brakeSystem: 'air',
      frontTrackWidth: 213,
      rearTrackWidth: 123,
      wheelbase: 123,
      frontWheelDiameter: 213,
      rearWheelDiameter: 123,
      rearAxle: 123,
      frontTireType: 'front_tire_type',
      frontTirePsi: 'front_tire_psi',
      rearTireType: 'rear_tire_type',
      rearTirePsi: 'rear_tire_psi'
    },
    fuel: {
      fuelType: {
        id: 1,
        name: 'Oil'
      },
      fuelQuality: '95',
      fuelTank1Capacity: 50,
      fuelTank2Capacity: 30
    },
    purchase: {
      vendor: {
        id: 1,
        name: 'Melvin Champlin'
      },
      date: '2019-09-19',
      amount: 123,
      odometerOnPurchase: 123,
      comment: 'comment'
    },
    drivers: [
      {
        id: 1,
        name: 'Samy Ahmed',
        photo: 'http://base_url/image/users/photo.png'
      },
      {
        id: 2,
        name: 'Ahmed Ezz',
        photo: 'http://base_url/image/users/photo.png'
      }
    ]
  };
}
